__turbopack_context__.v({
  "apply_button": "styles-module-scss-module__isnXcW__apply_button",
  "drawer_content": "styles-module-scss-module__isnXcW__drawer_content",
  "is_open": "styles-module-scss-module__isnXcW__is_open",
  "legend_container": "styles-module-scss-module__isnXcW__legend_container",
  "marker_control_container": "styles-module-scss-module__isnXcW__marker_control_container",
  "marker_count": "styles-module-scss-module__isnXcW__marker_count",
  "poi_container": "styles-module-scss-module__isnXcW__poi_container",
  "section_header": "styles-module-scss-module__isnXcW__section_header",
  "toggles": "styles-module-scss-module__isnXcW__toggles",
});
